var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.4 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2eb67d;\n      }\n\n      .st1 {\n        fill: #36c5f0;\n      }\n\n      .st2 {\n        fill: #ecb22e;\n      }\n\n      .st3 {\n        fill: #e01e5a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.2,80c0,7.3-5.9,13.2-13.2,13.2S.8,87.3.8,80s5.9-13.2,13.2-13.2h13.2v13.2ZM33.8,80c0-7.3,5.9-13.2,13.2-13.2s13.2,5.9,13.2,13.2v33c0,7.3-5.9,13.2-13.2,13.2s-13.2-5.9-13.2-13.2v-33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47,27c-7.3,0-13.2-5.9-13.2-13.2S39.7.6,47,.6s13.2,5.9,13.2,13.2v13.2h-13.2ZM47,33.7c7.3,0,13.2,5.9,13.2,13.2s-5.9,13.2-13.2,13.2H13.9c-7.3,0-13.2-5.9-13.2-13.2s5.9-13.2,13.2-13.2h33.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.9,46.9c0-7.3,5.9-13.2,13.2-13.2s13.2,5.9,13.2,13.2-5.9,13.2-13.2,13.2h-13.2v-13.2ZM93.3,46.9c0,7.3-5.9,13.2-13.2,13.2s-13.2-5.9-13.2-13.2V13.8c0-7.3,5.9-13.2,13.2-13.2s13.2,5.9,13.2,13.2c0,0,0,33.1,0,33.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.1,99.8c7.3,0,13.2,5.9,13.2,13.2s-5.9,13.2-13.2,13.2-13.2-5.9-13.2-13.2v-13.2h13.2ZM80.1,93.2c-7.3,0-13.2-5.9-13.2-13.2s5.9-13.2,13.2-13.2h33.1c7.3,0,13.2,5.9,13.2,13.2s-5.9,13.2-13.2,13.2h-33.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.fb96fc81c2dedf8da84fc0cb80f4af5e.svg";
export { ForwardRef as ReactComponent };